import CompaniesImage from "@/assets/login-companies-item-full.svg";

export function LoginSideBanner() {
    return (
        <div className="content-wrapper hidden lg:flex w-1/2 flex-col rounded-lg border-r relative min-w-[450px] max-w-[563px]">
            <div className="flex w-full h-2/3 justify-center bg-info/01 rounded-tr-lg rounded-tl-lg">
            </div>
            <div className="flex w-full h-1/3 justify-center bg-[#5049e5] rounded-br-lg rounded-bl-lg">
            </div>
            <div className="flex flex-col w-full h-full justify-center absolute bottom-0 right-0 pt-[162px]">
                <div className="flex flex-col items-center justify-center">
                    <div className="text-black text-2xl font-semibold mb-[16px] w-[418px] text-center">
                        Unlock live demand signals from companies
                    </div>
                </div>
                <div className="flex w-full h-full justify-end">
                    <div className="relative inline-block align-bottom">
                        <CompaniesImage className="block min-w-[400px] xl:w-[418px] 2xl:w-[560px]" />
                    </div>
                </div>
            </div>
        </div>
    );
}
